import BigNumber from 'bignumber.js'
import { ChainId, Pair, Token, WETH } from 'toonswap-sdk'
import { PAW, SUPRA, TOON, USDC, WBTC } from '../constants'

const ZERO = new BigNumber(0)
const WETH_MAINNET = WETH[ChainId.MAINNET]

// The pools the site reads USD prices from
export const PRICE_PAIRS: [Token, Token][] = [
  [TOON, SUPRA],
  [SUPRA, USDC],
  [WETH_MAINNET, USDC],
  [WBTC, WETH_MAINNET],
  [PAW, USDC],
]

// USD prices read straight from the pools' reserves, so they work as soon as a pool has liquidity, before any
// farm exists. `pairs` are the PRICE_PAIRS pools in order, null where a pool doesn't exist; an empty pool gives 0.
export const getPoolPricesUsd = (pairs: (Pair | null)[]) => {
  // how many of the pair's other token one `token` is worth
  const rate = (index: number, token: Token): BigNumber => {
    const pair = pairs[index]
    if (!pair || pair.reserve0.raw.toString() === '0' || pair.reserve1.raw.toString() === '0') {
      return ZERO
    }
    return new BigNumber(pair.priceOf(token).toSignificant(12))
  }
  const supra = rate(1, SUPRA) // USDC per SUPRA
  const eth = rate(2, WETH_MAINNET) // USDC per WETH
  return {
    supra,
    toon: rate(0, TOON).times(supra), // SUPRA per TOON x SUPRA price
    eth,
    wbtc: rate(3, WBTC).times(eth), // WETH per WBTC x ETH price
    paw: rate(4, PAW), // USDC per PAW
  }
}
